<template>
    <div class="container">
        <div class="layout-content">
            <global-header
                :school="1"
                :title="'방문예약 취소'"
            />
            <div class="content">
                <div class="input-area">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            예약 취소사유를 입력해주세요.
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <textarea v-model="reason" class="h48"/>
                    </div>
                </div>
                <div class="submit-btn">
                    <button @click="handleCancel">취소하기</button>
                    <button @click="handleBack" class="white">이전으로</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalHeader from "@/components/common/GlobalHeader.vue";
import { ERROR_TYPE } from "@/lib/type";
import { store } from "@/store";
import api from "@/api";

export default {
    name: "ReservationCancel",
    components: { GlobalHeader },
    data: () => ({
        reason: null,
    }),
    methods: {
        handleBack() {
            this.$router.back();
        },
        async handleCancel() {

            if(!this.reason || this.reason.length < 5) {
                this.$alert.danger({ message: '취소 사유를 5자 이상 입력해주세요.' });
                return;
            }

            try {
                let response = {};
                const data = {
                    user_type: store.auth.type,
                    token: store.auth.token,
                    reason: this.reason,
                };
                response = await api.cancelReservation(data, this.$route.params.id);

                if (response.result === "success") {
                    this.$alert.success({ message: '예약이 취소되었습니다.'});
                    this.$router.replace({ path: `/schools/${store.school.id}/visit/history` });
                } else {
                    throw new Error(response.code);
                }
            } catch (e) {
                this.handleErrorMessage(e);
            }
        },

        handleErrorMessage(error) {
            let result = null;

            if (typeof error === "object") {
                result = ERROR_TYPE[error.message];
            } else {
                result = ERROR_TYPE[error];
            }

            const message = !result ? "알 수 없는 오류 발생" : result;

            this.$alert.danger({ message });
        },
    },
    mounted() {
        // 학교정보 없으면 초기화면으로 보냄
        if(!store.school.id) {
            this.$router.replace({ path: `/schools/${this.$route.params.school}/visit` });
        }
    }
};
</script>

<style scoped lang="scss">

</style>